import { UcoastEl } from '@/scripts/core/UcoastEl';
import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import { qsaOptional, qsOptional, qsRequired } from '@/scripts/core/global'

export class MediaGallery extends UcoastEl {
	static htmlSelector = 'media-gallery'
	loadedAll: boolean
	currentSlideStatus: HTMLElement
	constructor() {
		super()
		this.loadedAll = false
		this.currentSlideStatus = qsRequired('[data-current-slide]', this)
		this.updateCounter = this.updateCounter.bind(this)
		const OPTIONS: EmblaOptionsType = {
			slidesToScroll: 1,
			align: 'start',
			containScroll: 'trimSnaps',
			dragFree: false,
			dragThreshold: 1,
			duration: 20,
		}

		const viewportNode = qsRequired('[data-embla-viewport]', this)
		const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
			WheelGesturesPlugin(),
			ClassNames(),
		])
		emblaApi.on('select', (emblaApi, _) => {
			this.loadSlidesInView()
			this.pauseSlidesOutsideView()
			this.updateCounter(emblaApi.selectedScrollSnap())
		})
	}

	updateCounter(index: number) {
		this.currentSlideStatus.textContent = `${index + 1}`
	}

	loadSlidesInView() {
		qsaOptional('.is-in-view', this)?.forEach((slide) => {
			void window.Ucoast.mediaManager.loadAllInContainer(slide)
		})
		const nextUp = qsOptional('.is-in-view + [data-embla-slide]', this)
		const nextNextUp = qsOptional('.is-in-view + [data-embla-slide] + [data-embla-slide]', this)

		if (nextUp) {
			void window.Ucoast.mediaManager.loadAllInContainer(nextUp)
		}
		if (nextNextUp)  {
			void window.Ucoast.mediaManager.loadAllInContainer(nextNextUp)
		}
	}
	pauseSlidesOutsideView() {
		qsaOptional('[data-embla-slide]:not(.is-in-view)', this)?.forEach((slide) => {
			void window.Ucoast.mediaManager.pauseAllInContainer(slide)
		})
	}
}
